var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2564_857812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20H8.125C5.3625 20 3.125 17.7625 3.125 15C3.125 12.2375 5.3625 10 8.125 10H23.75C25.475 10 26.875 11.4 26.875 13.125C26.875 14.85 25.475 16.25 23.75 16.25H10.625C9.9375 16.25 9.375 15.6875 9.375 15C9.375 14.3125 9.9375 13.75 10.625 13.75H22.5V11.875H10.625C8.9 11.875 7.5 13.275 7.5 15C7.5 16.725 8.9 18.125 10.625 18.125H23.75C26.5125 18.125 28.75 15.8875 28.75 13.125C28.75 10.3625 26.5125 8.125 23.75 8.125H8.125C4.325 8.125 1.25 11.2 1.25 15C1.25 18.8 4.325 21.875 8.125 21.875H22.5V20Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2564_857812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/Attachments.c22076d68291fed845379e36db4a5481.svg";
export { ForwardRef as ReactComponent };